








































import Vue from "vue";
import { axios } from "../../plugins";

const Path = "M 50 50\nm 0 -47\na 47 47 0 1 1 0 94\na 47 47 0 1 1 0 -94";
export default Vue.extend({
  name: "StatusCard",
  props: {
    header: { type: String },
    val: { type: String },
    sum: { type: String },
    valLabel: { type: String },
    sumLabel: { type: String },
    color: { type: String },
    format: { type: Function }
  },
  data() {
    return {
      loading: false,
      Path,
      value: "0",
      sums: "0",
      persent: "0"
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      const valRes = await this.getVal();
      const valSum = await this.getSum();

      if (valRes.data.data.result[0]) {
        this.value = parseFloat(valRes.data.data.result[0].value[1] || 0)
          .toFixed(2)
          .replace(".00", "");
        if (this.format) {
          this.value = this.format(this.value);
        }
      }
      if (valSum.data.data.result[0]) {
        this.sums = parseFloat(valSum.data.data.result[0].value[1] || 0)
          .toFixed(2)
          .replace(".00", "");

        if (this.format) {
          this.sums = this.format(this.sums);
        }
      }
      this.persent = ((parseFloat(this.value) / parseFloat(this.sums)) * 295.31)
        .toFixed(2)
        .replace(".00", "");

      this.loading = false;
    },
    getVal() {
      return axios.get(`/metrics/prom/api/v1/query?query=${this.val}`);
    },
    getSum() {
      return axios.get(`/metrics/prom/api/v1/query?query=${this.sum}`);
    }
  }
});
